import { render, staticRenderFns } from "./list.vue?vue&type=template&id=5d085dd2&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=5d085dd2&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d085dd2')) {
      api.createRecord('5d085dd2', component.options)
    } else {
      api.reload('5d085dd2', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=5d085dd2&", function () {
      api.rerender('5d085dd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/terminalActivity/actCustomer/list.vue"
export default component.exports